import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getVentilatorSelector } from '../../procedures/ventilator/selectors'
import { IVentilatorState } from '../../procedures/ventilator/store/ventilator.types'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'
import { generateClientCorrelationId } from '../../nemsisData/utils/customElements.util'

export function* addVentilatorItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const ventilatorState: IVentilatorState = yield select(getVentilatorSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  const {
    pta,
    addToTimeline,
    action,
    fiO2,
    airTemperature,
    airTemperatureUnit,
    key,
    time,
    date,
    assessedBy,
    comments,
    isEkgImport,
  } = ventilatorState
  if (addToTimeline) {
    const clientCorrelationId = generateClientCorrelationId(
      nemsisCodeOptions,
      TimelineConstants.VENTILATOR_PROCEDURE,
      null,
      {
        filter1: null,
        filter2: null,
        filter3: null,
      },
      key
    )
    const assessedByLabel = assessedBy?.name || ''
    const index = items.findIndex((item) => item.key === key)
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }
    const item: IItem = {
      key: key,
      clientCorrelationId,
      grid: true,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      itemType: 'Procedures',
      event: 'Ventilator',
      eventSubHeader: `By ${assessedByLabel}, Action: ${action?.name || ''}, FiO2: ${fiO2},
      Air Temperature: ${airTemperature}° ${airTemperatureUnit?.name?.toUpperCase() || ''}, Comments: ${comments}.`,
      rowActionType: TimelineConstants.SET_VENTILATOR_PROCEDURE_ITEM,
      defaultHref: TabConstants.VENTILATOR_PROCEDURE,
      date: dateTime,
      ...(isEkgImport && { isEkgImport: isEkgImport }),
    }
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addVentilatorItemSaga() {
  yield takeLatest([TimelineConstants.ADD_VENTILATOR_ITEM], addVentilatorItem)
}
